"use strict";

var _interopRequireDefault = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useDebouncedSearch = void 0;
var _slicedToArray2 = _interopRequireDefault(require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js"));
var _react = require("react");
var _noop = require("../../utils/noop");
var useDebouncedSearch = function useDebouncedSearch(querySearch, setQuerySearch) {
  var _useState = (0, _react.useState)(querySearch),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    search = _useState2[0],
    setSearch = _useState2[1];
  (0, _react.useEffect)(function () {
    if (querySearch !== search) {
      setSearch(querySearch);
    }
  }, [querySearch]);
  var onSearchChange = function onSearchChange(e) {
    setSearch(e.currentTarget.value);
  };
  (0, _react.useEffect)(function () {
    if (querySearch !== '' && search === '') {
      setQuerySearch(search);
      return _noop.noop;
    }
    var timeout = setTimeout(function () {
      if (search !== querySearch) {
        setQuerySearch(search);
      }
    }, 1000);
    return function () {
      return clearTimeout(timeout);
    };
  }, [search]);
  return [search, onSearchChange];
};
exports.useDebouncedSearch = useDebouncedSearch;